// Custom VFG components
// Action Button

<template>
    <div class="wrapper field-input" :class="schema.groupClasses" >
        <template v-for="(buttonSchema,index)  in buttonArray">
            <!--REGULAR BUTTON-->
            <button v-if="!buttonSchema.subs && visEval(buttonSchema.visible)" 
                :key="_uid+index" 
                :type="buttonSchema.submit?'submit':'button'" 
                @keyup.enter="enterKeyUp(buttonSchema)" 
                @click.prevent="regClick(buttonSchema.actions)" 
                :class="buttonSchema.buttonClasses" 
                :disabled="buttonSchema.disabled">
                <i v-if="buttonSchema.icon" :class="buttonSchema.icon"></i>
                {{buttonSchema.text}}
            </button>
            
            <!--DROPDOWN BUTTON-->
            <div class="btn-group"  v-bind:class="{ 'open': isOpen}" v-if="buttonSchema.subs">
                <button type="button" :key="_uid+index" @click.prevent="regClick(buttonSchema.actions)" :class="buttonSchema.buttonClasses" >
                    <i v-if="buttonSchema.icon" :class="buttonSchema.icon"></i>
                    {{buttonSchema.text}}
                </button>
                <button type="button"  @click.prevent="toggle" :class="buttonSchema.buttonClasses" data-toggle="dropdown" aria-expanded="true">
                    <span class="caret"></span>
                    <span class="sr-only">Toggle Dropdown</span>
                </button>
                
                <!--SUB ITEMS-->
                <ul class="dropdown-menu" role="menu">
                    <li  v-for="sub in buttonSchema.subs" :class="{ 'divider': sub.divider }" >
                        <a  v-if="sub.actions" @click.prevent="regClick(sub.actions)">{{sub.text}}</a>
                    </li>
                   
                    <!--<li class="divider"></li>-->
                    <!--<li><a href="#">Separated link</a>-->
                    <!--</li>-->
                </ul>
            </div>
        </template>
           
    </div>
</template>
 
<script>

    import { EventBus } from 'Js/eventBus';
 
    export default {
        props: ['text'],
        name: 'buttonblock',
        mixins: [ VueFormGenerator.abstractField],
        methods: {
        
            visEval: function(func) {
                return typeof func === "function" ? func() : (func != null ? func : 1)
            },
        
            regClick(actionsOrName) {
                    this.isOpen = false
                    if (actionsOrName.name) {
                        EventBus.$emit('processNamedAction', actionsOrName)
                    }
                    else {
                        // EventBus.$emit('processActions', actionsOrName)
                        EventBus.$emit('processActions', {
                            idWndw: this.formOptions.idWndw,
                            payload: actionsOrName
                        })
                    }
                },
        
        
                toggle() {
                    this.isOpen = !this.isOpen
                }
        
        },
        // TODO  enterKey hander for enter buttons
        computed: {
            // a computed getter
            buttonArray: function() {
                if (this.schema.group) {
                    return this.schema.group
                }
                else {
                var btnArray = []
                btnArray.push(this.schema)
                return btnArray
                }
            }
        },
        
        created() { 
            // if (this.schema.group) {
            //     this.buttonArray = this.schema.group
            // } else{
            //     this.buttonArray.push(this.schema) 
            // }
        },
        
        data() {
            return {
                isOpen: false
            }
        }
    }
</script>

<style>



</style>

                             
